import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MARK_APPROVED_REJECTED_AGENCY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.MARK_APPROVED_REJECTED_AGENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response,
            };
        case actionTypes.MARK_APPROVED_REJECTED_AGENCY_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            };
        case actionTypes.MARK_APPROVED_REJECTED_AGENCY_RESET:
            return {
                ...state,
                status: '',
                message: '',
            };
        case actionTypes.MARK_APPROVED_REJECTED_AGENCY_RESET_ALL:
            return initialState;
        default:
            return state;
    }
};
